module.exports = __webpack_public_path__ + "static/media/favorite_store_remove.ecb80c55.svg";